<template>
    <ProductSelection
        :multiple="false"
        :selected-product-group="selectedProductGroup"
        :selected-products="selectedProduct"
        :required="true"
        :errors="errors"
        :disabled="isPreLiveContract === false"
        :is-loading-contract-options="isLoadingContractOptions"
        :market-region-ids="customer.market_region_ids || []"
        @update="updateProduct"
        @product-group-update="handleGroupChange"
        @reset-product-id="resetProductId"
    />
</template>

<script>
import ProductSelection from '~@/Components/Products/Products/ProductSelection'

export default {
    name: 'ProductAndProductGroup',
    components: {
        ProductSelection
    },
    props: {
        contract: {
            type: Object,
            default: () => { return {} }
        },
        form: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        isLoadingContractOptions: {
            type: Boolean,
            default: false
        },
        isPreLiveContract: {
            type: Boolean,
            default: false
        }
    },
    emits: ['productDeselected', 'updateProductId', 'updateProductPlanId', 'updateProductGroupId', 'resetProductId'],
    data () {
        return {
            productId: this.contract.product_id,
            productGroupId: null
        }
    },
    computed: {
        selectedProductGroup () {
            if (this.productId) {
                return this.contract.product_group_id
            }

            return 0
        },
        selectedProduct () {
            if (this.productId) {
                return [{
                    value: this.productId,
                    label: `${this.contract.product_name}${this.contract.product_retired ? ' (' + this.__('products.products.index.retired') + ')' : ''} (${this.productId})`
                }]
            }

            return []
        }
    },
    methods: {
        updateProduct (value) {
            if (value?.value === '') {
                this.$emit('productDeselected')
            }

            if (Number(this.form.product_id) !== Number(value.value) && Number(value.value) !== 0) {
                this.$emit('updateProductId', value)

                this.$emit('updateProductPlanId', null)
            }
        },
        handleGroupChange (value) {
            this.productGroupId = value

            this.$emit('updateProductGroupId', Number(value))
            this.$emit('updateProductPlanId', null)
        },
        resetProductId () {
            this.$emit('resetProductId')
        }
    }
}
</script>
